<p class="ms-300" [ngSwitch]="user?.role">

  <app-admin-dashboard *ngSwitchCase="'hospitaladmin'"></app-admin-dashboard>
  <app-admin-dashboard *ngSwitchCase="'Admin'"></app-admin-dashboard>

  <app-doctors-dashboard *ngSwitchCase="'doctor'"></app-doctors-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'primaryhealthcareprovider'"></app-doctors-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'Doctor'"></app-doctors-dashboard>

  <app-nurse-dashboard *ngSwitchCase="'healthcareassistant'"></app-nurse-dashboard>
  <app-nurse-dashboard *ngSwitchCase="'Nurse'"></app-nurse-dashboard>
  <app-nurse-dashboard *ngSwitchCase="'nursemidwife'"></app-nurse-dashboard>

  <app-lab-dashboard *ngSwitchCase="'labtechnician'"></app-lab-dashboard>
  <app-lab-dashboard *ngSwitchCase="'LabTechnician'"></app-lab-dashboard>

  <app-pharmacy-dashboard *ngSwitchCase="'pharmacist'"></app-pharmacy-dashboard>
  <app-pharmacy-dashboard *ngSwitchCase="'Pharmacy'"></app-pharmacy-dashboard>
  <app-pharmacy-dashboard *ngSwitchCase="'pharmacy'"></app-pharmacy-dashboard>

  <app-receptionist-dashboard *ngSwitchCase="'healthcareadmin'"></app-receptionist-dashboard>
  <app-receptionist-dashboard *ngSwitchCase="'Receptionist'"></app-receptionist-dashboard>
  <app-cashier-dashboard *ngSwitchCase="'cashier'"></app-cashier-dashboard>

  <app-patient-dashboard *ngSwitchCase="'patient'"></app-patient-dashboard>
  <app-patient-dashboard *ngSwitchCase="'Patient'"></app-patient-dashboard>
  <app-serviceprovider-dashboard *ngSwitchCase="'alliedhealthprofessional'"></app-serviceprovider-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'remotedoctor'" [isConsultant]="true"></app-doctors-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'Consultant'" [isConsultant]="true"></app-doctors-dashboard>
  
  <app-superadmin-dashboard *ngSwitchCase="'superadmin'"></app-superadmin-dashboard>
  <app-superadmin-dashboard *ngSwitchCase="'SuperAdmin'"></app-superadmin-dashboard>

  <!-- Default fallback -->
  <app-patient-dashboard *ngSwitchDefault></app-patient-dashboard>

</p>
<div>
   <!-- =============== FLOATING HELP BUTTON =============== -->
  <button 
    mat-fab 
    class="floating-help-btn"
    [matMenuTriggerFor]="helpMenu"
    aria-label="Help and Documentation">
    <mat-icon>help_outline</mat-icon>
  </button>

  <!-- Help Menu Dropdown -->
  <mat-menu #helpMenu="matMenu" class="help-menu">
    
    <!-- Documentation Link -->
    <button 
      mat-menu-item 
      (click)="goToDocumentation('getting-started')">
      <mat-icon>menu_book</mat-icon>
      <span>Help and Documentation</span>
    </button>

  </mat-menu>
</div>
